// extracted by css-extract-rspack-plugin
export default {"number":"W0PbNb6tEYdxpUeE","popover":"lrNG8sTbXgL6Pwpu","popoverActions":"T0aBbjPBkXgS1cqT"};